import SignUpOrderNoPage from "./SignUpOrderNo";
import RegisterPage from "./RegisterPage";

const SignUpOrderNo = SignUpOrderNoPage;
const Register = RegisterPage;

export { Register, SignUpOrderNo };
